export type GetInitialsInput = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string;
  workspaceName?: string;
  avatarFallbackName?: string;
  fullName?: string;
};

export function getInitials({
  firstName,
  lastName,
  email,
  workspaceName,
  avatarFallbackName,
  fullName,
}: GetInitialsInput): string {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  if (fullName) {
    const words = fullName.trim().split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
      return `${words[0][0]}${words[1][0]}`.toUpperCase();
    }
    if (words.length === 1) {
      return words[0][0].toUpperCase();
    }
  }

  if (email) {
    return email.charAt(0).toUpperCase();
  }

  if (workspaceName) {
    return workspaceName.charAt(0).toUpperCase();
  }

  if (avatarFallbackName) {
    return avatarFallbackName.charAt(0).toUpperCase();
  }

  return "?";
}
